import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  newFranchiseManualSidebar: {
    id: undefined,
    visible: false,
    saveAction: undefined,
  },
  publishManualVersionSidebar: {
    id: undefined,
    manualName: undefined,
    visible: false,
    saveAction: undefined,
  },
  franchiseManualsSearchResult: [],
  myFranchiseManualCycle: undefined,
}

export default {
  state,
  actions,
  getters,
  mutations
}
